// AUTO-GENERATED GraphQL Builder for ResaleTerm
import * as Builders from '../';
export class ResaleTermBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  partnerVendorId(){ return this.add('partnerVendorId'); }
  resellerVendorId(){ return this.add('resellerVendorId'); }
  offeringId(){ return this.add('offeringId'); }
  offeringPackageId(){ return this.add('offeringPackageId'); }
  eventSessionId(){ return this.add('eventSessionId'); }
  offeringItemId(){ return this.add('offeringItemId'); }
  price(){ return this.add('price'); }
  isEnabled(){ return this.add('isEnabled'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  eventSession(b?:(q:Builders.EventSessionBuilder)=>void){
    if(this.depth>=5||this.v.has('eventSession'))return this;
    this.v.add('eventSession');
    const n=new Builders.EventSessionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`eventSession { ${inner} }`);
    return this;
  }

  offering(b?:(q:Builders.OfferingBuilder)=>void){
    if(this.depth>=5||this.v.has('offering'))return this;
    this.v.add('offering');
    const n=new Builders.OfferingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offering { ${inner} }`);
    return this;
  }

  offeringItem(b?:(q:Builders.OfferingItemBuilder)=>void){
    if(this.depth>=5||this.v.has('offeringItem'))return this;
    this.v.add('offeringItem');
    const n=new Builders.OfferingItemBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringItem { ${inner} }`);
    return this;
  }

  offeringPackage(b?:(q:Builders.OfferingPackageBuilder)=>void){
    if(this.depth>=5||this.v.has('offeringPackage'))return this;
    this.v.add('offeringPackage');
    const n=new Builders.OfferingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringPackage { ${inner} }`);
    return this;
  }

  partnerVendor(b?:(q:Builders.VendorBuilder)=>void){
    if(this.depth>=5||this.v.has('partnerVendor'))return this;
    this.v.add('partnerVendor');
    const n=new Builders.VendorBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`partnerVendor { ${inner} }`);
    return this;
  }

  resellerVendor(b?:(q:Builders.VendorBuilder)=>void){
    if(this.depth>=5||this.v.has('resellerVendor'))return this;
    this.v.add('resellerVendor');
    const n=new Builders.VendorBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resellerVendor { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }
}
